var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5 0H3.5C1.575 0 0.0175 1.575 0.0175 3.5L0 24.5C0 26.425 1.575 28 3.5 28H31.5C33.425 28 35 26.425 35 24.5V3.5C35 1.575 33.425 0 31.5 0ZM30.8 7.4375L18.4275 15.1725C17.8675 15.5225 17.1325 15.5225 16.5725 15.1725L4.2 7.4375C4.02452 7.33899 3.87086 7.20591 3.74831 7.04629C3.62575 6.88668 3.53686 6.70386 3.48701 6.5089C3.43716 6.31394 3.42738 6.11089 3.45827 5.91204C3.48917 5.71319 3.56009 5.52267 3.66674 5.35203C3.7734 5.18138 3.91357 5.03415 4.07877 4.91924C4.24397 4.80434 4.43077 4.72414 4.62787 4.68352C4.82496 4.6429 5.02825 4.64269 5.22542 4.68291C5.4226 4.72313 5.60956 4.80293 5.775 4.9175L17.5 12.25L29.225 4.9175C29.3904 4.80293 29.5774 4.72313 29.7746 4.68291C29.9718 4.64269 30.175 4.6429 30.3721 4.68352C30.5692 4.72414 30.756 4.80434 30.9212 4.91924C31.0864 5.03415 31.2266 5.18138 31.3333 5.35203C31.4399 5.52267 31.5108 5.71319 31.5417 5.91204C31.5726 6.11089 31.5628 6.31394 31.513 6.5089C31.4631 6.70386 31.3743 6.88668 31.2517 7.04629C31.1291 7.20591 30.9755 7.33899 30.8 7.4375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.e6592705bf7f9f4f4bd5fd527611128b.svg";
export { ForwardRef as ReactComponent };